module.exports = __webpack_public_path__ + "img/currency.27f3bb17.png";